import { getLabels } from '../GenericFunctions';

export { getLabels };
